<template>
  <div class="drawer-wrapper" v-loading.fullscreen.lock="loading">
    <el-drawer :wrapperClosable="true" :title="title" :visible.sync="dialogVisible" size="50%"
               :before-close="handleClose" direction="rtl">

      <div class="demo-drawer__content">
        <el-form :model="addFrom" :rules="rules" ref="ruleForm">
          <el-row :gutter="35">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="服务方式：" prop="fw_methond_text" :label-width="formLabelWidth">
			  {{addFrom.fw_methond_text || '-'}}
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="服务需求：" prop="fw_contents" :label-width="formLabelWidth">
			  {{addFrom.fw_contents || '-'}}
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20" v-if="group_id == 1 || group_id == 2">
              <el-form-item label="审核" prop="is_sh" :label-width="formLabelWidth">
				<el-radio v-model="addFrom.is_sh" :label="1">审核通过</el-radio>
				<el-radio v-model="addFrom.is_sh" :label="2">审核驳回</el-radio>
			</el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20" v-if="(group_id == 1 || group_id == 2) && addFrom.is_sh == 1">
              <el-form-item label="处理部门" prop="is_sh" :label-width="formLabelWidth">
			<el-checkbox-group v-model="deal_group">
				<el-checkbox v-for="item in groups" :label="item.id">{{ item.name }}</el-checkbox>
			</el-checkbox-group>
		  </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20" v-if="group_id == 1 || group_id == 2">
              <el-form-item label="审核意见" prop="sh_comments" :label-width="formLabelWidth">
                <el-input v-model="addFrom.sh_comments" placeholder="请输入审核意见" clearable style="width: 90%;" type="textarea"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20" v-if="group_id == 1 || group_id == 2">
              <el-form-item label="审核附件" :label-width="formLabelWidth">
                <el-upload
                  :action="uploadUrl"
                  :headers="uploadHeaders"
                  :file-list="fileList"
                  :on-success="handleUploadSuccess"
                  :on-remove="handleRemove"
                  :before-upload="beforeUpload"
                  drag
                  multiple
                  :limit="10"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">支持多个文件上传，最多10个</div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20" v-if="group_id > 2">
              <el-form-item label="审核意见：" :label-width="formLabelWidth">
                {{addFrom.sh_comments || '-'}}
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20" v-if="group_id > 2 && addFrom.sh_files && addFrom.sh_files.length > 0">
              <el-form-item label="审核附件：" :label-width="formLabelWidth">
                <div v-for="(file, index) in addFrom.sh_files" :key="index" class="file-item">
                  <a :href="getFileUrl(file.url)" target="_blank" class="file-link">
                    <i class="el-icon-document"></i> {{ file.name }}
                  </a>
                </div>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20" v-if="group_id > 2">
              <el-form-item label="处理描述" prop="deal_comments" :label-width="formLabelWidth">
                <el-input v-model="addFrom.deal_comments" placeholder="请输入处理描述" clearable style="width: 90%;" type="textarea"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20" v-if="group_id > 2">
              <el-form-item label="处理附件" :label-width="formLabelWidth">
                <el-upload
                  :action="uploadUrl"
                  :headers="uploadHeaders"
                  :file-list="dealFileList"
                  :on-success="handleDealUploadSuccess"
                  :on-remove="handleDealRemove"
                  :before-upload="beforeUpload"
                  drag
                  multiple
                  :limit="10"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">支持多个文件上传，最多10个</div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="AddNone">取 消</el-button>
        <el-button type="primary" @click="addPush">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {apis} from "@/api/infos";
import {administratorsAPI} from "@/api/account/administrators";
import {processErrors} from "@/utils/errorHandler";
import { Session } from '@/utils/storage';
const api = apis();
const adminAPI = administratorsAPI();
export default {
  props: ['dialogVisible', "editID", "type"],
  components: {},
  data() {
    return {
      title: "办理",
      formLabelWidth: "140px",
      addFrom: {
        name: "",
        listorder:'',
        sh_files: [],
        deal_files: []
      }, 
	  loading: false,
	  isask: false,
      rules: {
      },
	  groups: [],
	  deal_group: [],
	  group_id: 0,
      uploadUrl: '',
      uploadHeaders: {},
      fileList: [],
      dealFileList: []
    };
  },
  mounted() {
	let that = this;
	let group_id = Session.get("roleId");
	that.group_id = group_id;
	that.title = group_id > 2 ? "办理" : "审核"
	const token = Session.get('token');
	that.uploadUrl = (process.env.VUE_APP_BASE_API || '').replace(/\/$/, '') + '/admin/upload/project_file?token=' + token;
	adminAPI.roleList({child: 1}).then(res => {
		that.groups = res.data.data
	})
	api.ApiInfosInfo({id: that.editID}).then(res => {
		if (res.code == 0) {
			that.addFrom = res.data
			that.addFrom.deal_group = res.data.deal_group ? res.data.deal_group.split(',') : ''
			that.deal_group = that.addFrom.deal_group || [];
			that.addFrom.is_sh = res.data.is_sh == 0 ? 1 : 0;
			if (group_id == 1 || group_id == 2) {
				that.addFrom.sh_files = [];
			} else {
				that.addFrom.sh_files = res.data.sh_files || [];
				that.addFrom.deal_files = [];
			}
		} else {
			processErrors(res);
		}
	})
  },
  methods: {
    getFileUrl(url) {
      if (!url) return '';
      if (url.startsWith('http://') || url.startsWith('https://')) {
        return url;
      }
      return process.env.VUE_APP_BASE_API + url;
    },
    handleUploadSuccess(response, file, fileList) {
      if (response.code === 0) {
        this.addFrom.sh_files.push({
          name: file.name,
          url: response.data.url
        });
        this.$message.success('上传成功');
      } else {
        this.$message.error(response.msg || '上传失败');
        this.fileList = this.fileList.filter(item => item.uid !== file.uid);
      }
    },
    handleRemove(file, fileList) {
      const index = this.addFrom.sh_files.findIndex(item => item.name === file.name);
      if (index > -1) {
        this.addFrom.sh_files.splice(index, 1);
      }
    },
    beforeUpload(file) {
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error('文件大小不能超过50MB!');
      }
      return isLt50M;
    },
    handleDealUploadSuccess(response, file, fileList) {
      if (response.code === 0) {
        // 找到当前部门对应的deal_files项
        const groupId = this.group_id;
        const groupName = (this.groups.find(g => g.id == groupId) || {}).name || '';
        let deptItem = this.addFrom.deal_files.find(d => d.name === groupName);
        if (!deptItem) {
          deptItem = { name: groupName, files: [] };
          this.addFrom.deal_files.push(deptItem);
        }
        deptItem.files.push({ name: file.name, url: response.data.url });
        this.$message.success('上传成功');
      } else {
        this.$message.error(response.msg || '上传失败');
        this.dealFileList = this.dealFileList.filter(item => item.uid !== file.uid);
      }
    },
    handleDealRemove(file, fileList) {
      const groupId = this.group_id;
      const groupName = (this.groups.find(g => g.id == groupId) || {}).name || '';
      const deptItem = this.addFrom.deal_files.find(d => d.name === groupName);
      if (deptItem) {
        const index = deptItem.files.findIndex(f => f.name === file.name);
        if (index > -1) deptItem.files.splice(index, 1);
      }
    },
    handleClose(done) {
      this.$emit('NoneDlog');
      this.$refs['ruleForm'].resetFields();
    },

    AddNone() {
      this.addFrom = {
        name: "",
        listorder:'',
        sh_files: [],
        deal_files: []
      }
      this.fileList = []
      this.dealFileList = []
      this.title = ""
      this.$refs['ruleForm'].resetFields();
      this.$emit('NoneDlog');
    },

    addPush() {
	  let that = this;
	  if(that.isask){
		  return;
	  }
      that.loading = true
	  that.isask = true;
	  that.addFrom.deal_group = that.deal_group.join(',')
      that.$refs['ruleForm'].validate((valid) => {
        if (valid) {
		  if(that.group_id > 2){
			  let createText = "处理成功";
			  api.ApiInfoDeal(that.addFrom).then(res => {
				that.isask = false;
				that.loading = false;
			    if (res.code == 0) {
			      that.$message({
			        message: createText,
			        type: 'success'
			      });
			      that.$emit('AddOk');
			    } else {
			      processErrors(res);
			    }
			  })
		  }else{
			  let createText = "审核成功";
			  api.ApiInfoSh(that.addFrom).then(res => {
				that.isask = false;
				that.loading = false;
			    if (res.code == 0) {
			      that.$message({
			        message: createText,
			        type: 'success'
			      });
			      that.$emit('AddOk');
			    } else {
			      processErrors(res);
			    }
			  })
		  }
        } else {
          return false;
        }
      });
    }
  },
}
</script>
<style lang='scss' scoped>
.demo-drawer__content {
  height: calc(100% - 80px); /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto; /* 添加垂直滚动条 */
  margin-top: 20px;
  overflow-x: hidden;
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  margin: 0 10px;
  width: calc(50% - 20px);
}

.file-item {
  margin-bottom: 8px;
}

.file-link {
  color: #409EFF;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  
  &:hover {
    color: #66b1ff;
    text-decoration: underline;
  }
  
  i {
    margin-right: 5px;
  }
}
</style>
